import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveImage,
  CtaButton,
  CtaShell,
  Accordion,
} from '@web/molecules';
import {
  StyledDetails,
  DetailsHeader,
  DetailsIcon,
  DetailsDescription,
  DetailsBody,
  NoticeBody,
  ButtonWrapper,
} from './styles';

export const Details = ({
  title,
  icon,
  notice,
  description,
  details,
  buttonVariant = 'yellow',
  link = null,
  headerText,
}) => {
  const linkAlignment = link?.alignment || 'center';

  return (
    <StyledDetails>
      {title || description || notice ? (
        <DetailsDescription>
          <DetailsHeader>
            {title}
            {icon && (
              <DetailsIcon>
                <ResponsiveImage
                  src={icon.src}
                  alt={icon.alt}
                  height={icon.height}
                  width={icon.width}
                />
              </DetailsIcon>
            )}
          </DetailsHeader>
          {notice && <NoticeBody>{notice}</NoticeBody>}
          {description && <DetailsBody>{description}</DetailsBody>}
        </DetailsDescription>
      ) : null}
      <Accordion details={details} buttonVariant={buttonVariant} />
      {link && (
        <ButtonWrapper $alignment={linkAlignment}>
          <CtaShell
            alignment={linkAlignment}
            fullWidth={link.fullWidth}
            fullWidthMobile={link.fullWidthMobile}
            fullWidthDesktop={link.fullWidthDesktop}
          >
            <CtaButton
              href={link.target}
              variant={buttonVariant}
              icon={link.icon}
              iconAlignment={link.iconAlignment}
              alignment={linkAlignment}
              fullWidth={link.fullWidth}
              fullWidthMobile={link.fullWidthMobile}
              fullWidthDesktop={link.fullWidthDesktop}
              headerText={headerText || link.headerText}
            >
              {link.text}
            </CtaButton>
          </CtaShell>
        </ButtonWrapper>
      )}
    </StyledDetails>
  );
};

Details.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  notice: PropTypes.string,
  description: PropTypes.string,
  details: PropTypes.array.isRequired,
  buttonVariant: PropTypes.string.isRequired,
  link: PropTypes.object,
  headerText: PropTypes.string,
};
